<template>
  <div>
    <app-form-holder>
      <!--  -->
      <!--  -->

      <!--  -->
      <!--  -->
      <app-form-title :title="title"> </app-form-title>
      <div txt-center>
        <div txt-center>Welcome to E4T!</div>
        <div
          txt-center
          v-if="invitation !== undefined && invitation.invitedBy !== undefined"
        >
          <span>Thanks for accepting </span>
          <span primary f-w-700>{{ invitation.invitedBy.firstName }}</span>
          <span> 's invite — glad you could join us! </span>
        </div>
      </div>
      <!--  -->
      <!-- signup form -->
      <div>
        <el-form
          v-if="keyIsValid !== false"
          v-loading="loading"
          :rules="rules"
          @submit.prevent
          class="App-Styled-Form"
          :label-position="'top'"
          label-width="100px"
          :model="form"
          style="margin-top: 12px"
        >
          <!-- Names -->
          <!--  -->
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item prop="firstName" label="firstName">
                <template v-slot:label>
                  <el-icon>
                    <User />
                  </el-icon>
                  First Name
                </template>
                <el-input placeholder="John" v-model="form.firstName" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="lastName" label="lastName">
                <template v-slot:label>
                  <el-icon>
                    <User />
                  </el-icon>
                  Last Name
                </template>
                <el-input placeholder="Doe" v-model="form.lastName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!--  -->
          <!-- Email -->
          <el-form-item
            v-if="form.key === undefined"
            prop="email"
            label="Email"
          >
            <template v-slot:label>
              <el-icon>
                <Message />
              </el-icon>
              Email
            </template>
            <el-input placeholder="johndoe@e4t.com" v-model="form.email" />
          </el-form-item>
          <!--  -->
          <!-- Password -->
          <el-tooltip
            placement="top"
            content="
            Should contain at least one special character, Should contain capital letter, 
            Min 8 characters, Max 35 characters.
            "
          >
            <div>
              <el-form-item prop="password" label="Password">
                <template v-slot:label>
                  <el-icon>
                    <lock />
                  </el-icon>
                  Password
                </template>
                <el-input
                  placeholder="********"
                  type="password"
                  v-model="form.password"
                  show-password
                />
              </el-form-item>
              <app-password-strength :password="form.password" />
            </div>
          </el-tooltip>
          <!--  -->
          <div txt-center>
            <el-button
              :disabled="
                (!form.email && form.key === undefined) ||
                !form.password ||
                !form.firstName ||
                !form.lastName ||
                !tickedTerms ||
                !tickedPrivacy
              "
              is-block
              size="large"
              type="primary"
              icon="el-icon-right"
              @click="submit"
            >
              Create An Account
            </el-button>
          </div>
          <!--  -->
          <div style="margin-top: 12px">
            <el-space :size="18" fill>
              <el-checkbox v-model="tickedTerms" size="small">
                <small>
                  By creating an account and using our platform, to agree to our
                  <el-link
                    @click="navigateToTerms('terms-of-service')"
                    style="font-size: inherit"
                  >
                    Terms of Service
                  </el-link>
                </small>
              </el-checkbox>
              <el-checkbox v-model="tickedPrivacy" size="small">
                <small>
                  Please tick this box to confirm that you have read our
                  <el-link
                    @click="navigateToTerms('privacy-policy')"
                    style="font-size: inherit"
                  >
                    privacy policy terms
                  </el-link>
                  which describes how we use personal data
                </small>
              </el-checkbox>
            </el-space>
          </div>
        </el-form>
        <!--  -->
        <div v-else-if="keyIsValid === false">
          <el-divider />
          <el-empty :image="img">
            <template #description>
              <h3 m-tb-0>Oops, Invalid Link!</h3>
              <p>
                The link used is expired or invalid, <br />
                where did you get it from?
              </p>
            </template>
            <router-link to="/login">
              <el-button
                is-borderless
                plain
                type="primary"
                icon="el-arrow-right"
              >
                Sign In
              </el-button>
            </router-link>
          </el-empty>
        </div>

        <!--  -->
      </div>
      <!--  -->
      <!--  -->
      <el-divider />
      <!--  -->
      <!-- Other links -->
      <div txt-center>
        <el-space
          w-100
          :fill="true"
          alignment="center"
          direction="vertical"
          :size="4"
        >
          <el-row align="middle" justify="center">
            <el-col>
              <div txt-center>
                Have an account?
                <router-link to="/login">
                  <el-link type="primary"> Sign In</el-link> </router-link
                >!
              </div>
            </el-col>
          </el-row>
          <el-row align="middle" justify="center">
            <el-col v-if="asTalent" txt-center :span="24">
              <router-link to="/signup/founder">
                <el-link> Join as a founder </el-link>
              </router-link>
            </el-col>
            <el-col v-else txt-center :span="24">
              <el-link>Talents Get Invited ?</el-link>
            </el-col>
          </el-row>
        </el-space>
      </div>
      <!--  -->
    </app-form-holder>
  </div>
</template>

<script lang="ts">
import { LoginResponse, SignupResponse } from "@/@auth/interfaces";
import { ErrorUtil, Invitation, TermLink, TermsLinksClass } from "@/shared";
import { Lock, Message, User } from "@element-plus/icons";
import { Options, Vue } from "vue-class-component";
import { AuthToken, AuthUtil } from "../../classes";
import img from "@/assets/illustrations/user/experience.svg";

@Options({
  components: { Message, Lock, User },
  data() {
    return { keyIsValid: undefined, invitation: undefined };
  },
})
export default class extends Vue {
  img = img;

  loading = false;

  resp;

  tickedTerms = false;
  tickedPrivacy = false;
  /**
   * Form data
   */
  form = {
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    password: undefined,
    type: undefined as unknown,
    key: undefined as unknown,
  };
  rules = {
    firstName: [
      { required: true, message: "First name is required!", trigger: "blur" },
    ],
    lastName: [
      { required: true, message: "Last Name is required!", trigger: "blur" },
    ],
    email: [
      { required: true, message: "Email is required!", trigger: "blur" },
      {
        type: "email",
        message: "Please input correct email address",
        trigger: ["blur", "change"],
      },
    ],
    password: [
      { required: true, message: "Password is required!", trigger: "blur" },
      {
        min: 8,
        max: 35,
        message: "Length should be 8 to 35 characters",
        trigger: "blur",
      },
    ],
  };

  /**
   * @sends the signup request to the API
   */
  submit(): void {
    this.loading = true;
    this.$api.main
      .post<LoginResponse>("/v1/auth/signup", this.form)
      .then((resp) => {
        this.signupFinalize(resp.data);
      })
      .catch((err) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: ErrorUtil.stringify(err),
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
  /**
   * When mounted
   */
  mounted() {
    this.form.type = this.type;
    if (this.$route.query.key !== undefined) {
      this.verifyKey();
    }
  }

  /**
   * @verifies if the key provided is still valid
   */
  verifyKey() {
    this.loading = true;
    this.$api.main
      .get<Invitation>(`/v1/invitations/verify?key=${this.$route.query.key}`)
      .then((resp) => {
        (this.$data as any).invitation = resp.data;
        (this.$data as any).keyIsValid = true;
        this.form.key = this.$route.query.key;
      })
      .catch((err) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: "Invalid Invitation key",
        });
        (this.$data as any).keyIsValid = false;
        setTimeout(() => {
          this.$router.push("/login");
        }, 4000);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  /**
   * @param link
   */
  navigateToTerms(link: TermLink) {
    TermsLinksClass.navigateOut(link);
  }
  /**
   * On a successfull signup
   * It sets the cookie and then decides where to go
   * @param response
   */
  signupFinalize(response: SignupResponse) {
    AuthToken.setToken(response.token);
    this.redirectUser(response);
  }
  /**
   * Redirects users based on hi/her role
   * @param response
   */
  redirectUser(response: SignupResponse) {
    AuthUtil.redirectUser(response.user);
  }
  /**
   * @determines if the creation is for talent or founder
   */
  get asTalent(): boolean {
    return (this.$route.path as string).search("talent") !== -1;
  }
  get type(): "founder" | "talent" {
    return this.asTalent ? "talent" : "founder";
  }
  /**
   * @detemines the form title
   */
  get title(): string {
    return this.asTalent ? "Join as a talent" : "Join as a founder";
  }
}
</script>

<style lang="scss">
.el-popper {
  max-width: 400px;
}
</style>
